import React from 'react';
import HomeView from './views/HomeView';

const HomeController = () => <HomeView />;

export default HomeController;
